"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _withReduxForm = _interopRequireDefault(require("./../../libs/hocs/withReduxForm"));

var _RenderIf = _interopRequireDefault(require("../RenderIf"));

var _RequiredAsterisk = _interopRequireDefault(require("../RequiredAsterisk"));

var _utils = require("./../../libs/utils");

var _context = require("./context");

var _container = _interopRequireDefault(require("./styled/container"));

var _label = _interopRequireDefault(require("./styled/label"));

var _optionsContainer = _interopRequireDefault(require("./styled/optionsContainer"));

var _errorText = _interopRequireDefault(require("../Input/styled/errorText"));

/**
 * A VisualPicker can be either radio buttons, checkboxes, or links that are visually enhanced.
 * @category Form
 */
var VisualPicker =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(VisualPicker, _Component);

  function VisualPicker(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, VisualPicker);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(VisualPicker).call(this, props));
    _this.errorId = (0, _utils.uniqueId)('error-message');
    _this.groupNameId = props.name || (0, _utils.uniqueId)('visual-picker');
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(VisualPicker, [{
    key: "getErrorMessageId",
    value: function getErrorMessageId() {
      var error = this.props.error;

      if (error) {
        return this.errorId;
      }

      return undefined;
    }
  }, {
    key: "handleChange",
    value: function handleChange(optionName, isChecked) {
      var _this$props = this.props,
          onChange = _this$props.onChange,
          multiple = _this$props.multiple,
          value = _this$props.value;
      var currentValue = optionName;

      if (multiple) {
        if (!Array.isArray(value)) {
          currentValue = isChecked ? [optionName] : [];
        } else {
          currentValue = isChecked ? [].concat((0, _toConsumableArray2["default"])(value), [optionName]) : value.filter(function (item) {
            return item !== optionName;
          });
        }
      }

      onChange(currentValue);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          style = _this$props2.style,
          label = _this$props2.label,
          required = _this$props2.required,
          error = _this$props2.error,
          id = _this$props2.id,
          children = _this$props2.children,
          value = _this$props2.value,
          multiple = _this$props2.multiple,
          className = _this$props2.className,
          size = _this$props2.size;
      var context = {
        ariaDescribedby: this.getErrorMessageId(),
        groupName: this.groupNameId,
        privateOnChange: this.handleChange,
        value: value,
        multiple: multiple,
        size: size
      };
      return _react["default"].createElement(_container["default"], {
        id: id,
        className: className,
        style: style
      }, _react["default"].createElement(_RenderIf["default"], {
        isTrue: label
      }, _react["default"].createElement(_label["default"], null, _react["default"].createElement(_RequiredAsterisk["default"], {
        required: required
      }), label)), _react["default"].createElement(_optionsContainer["default"], null, _react["default"].createElement(_context.Provider, {
        value: context
      }, children)), _react["default"].createElement(_RenderIf["default"], {
        isTrue: error
      }, _react["default"].createElement(_errorText["default"], {
        id: this.getErrorMessageId()
      }, error)));
    }
  }]);
  return VisualPicker;
}(_react.Component);

VisualPicker.propTypes = {
  /** The name of VisualPicker. */
  name: _propTypes["default"].string,

  /** The value of the element. */
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),

  /** The id of the outer element. */
  id: _propTypes["default"].string,

  /** The action triggered when a value attribute changes. */
  onChange: _propTypes["default"].func,

  /** If is set to true the VisualPicker is required. This value defaults to false. */
  required: _propTypes["default"].bool,

  /** The title at the top of the VisualPicker component. */
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /** Specifies that an VisualPicker must be filled out before submitting the form. */
  error: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /** The class name of the root element. */
  className: _propTypes["default"].string,

  /** It is an object with custom style applied to the root element. */
  style: _propTypes["default"].object,

  /** The size of the VisualPicker. Valid values are small, medium, and large.
   * This value defaults to medium. */
  size: _propTypes["default"].oneOf(['small', 'medium', 'large']),

  /**
   * This prop that should not be visible in the documentation.
   * @ignore
   */
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].object]),

  /** If true then a multiple selection is allowed */
  multiple: _propTypes["default"].bool
};
VisualPicker.defaultProps = {
  name: null,
  value: undefined,
  id: undefined,
  onChange: function onChange() {},
  required: false,
  label: '',
  error: null,
  className: undefined,
  style: undefined,
  size: 'medium',
  children: [],
  multiple: false
};

var _default = (0, _withReduxForm["default"])(VisualPicker);

exports["default"] = _default;